var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"al-table_pagination-default_container"},[_c(_vm.paginationComponent,{ref:"paginationComponent",tag:"component",attrs:{"totalPage":_vm.totalPage,"min":_vm.displayAllLimit,"page":_vm.page},on:{"changePage":_vm.changePage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }